import "./../css/style.scss";
import $ from 'jquery';

var euVisible = false;
var scrollTop;

function euLogo(scroll) {
    if ($("#eu-status").length > 0) {
        if (scroll < 100) {
            if (!euVisible) {
                euVisible = true;
                $("#eu-status").css("visibility", "visible");
                $("#eu-status").animate({
                    opacity: 1,
                    right: '0'
                }, 300);
            }
        } else {
            if (euVisible) {
                euVisible = false;

                $("#eu-status").animate({
                    opacity: 0,
                    right: '-100px'
                }, 300, function () {
                    $(this).css("visibility", "hidden");
                });
            }
        }
    }
}
$(window).scroll(function () {
    scrollTop = $(window).scrollTop();
    euLogo(scrollTop);
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > 20) {
        $('#header').addClass('scrolled');
    } else {
        $('#header').removeClass('scrolled');
    }
});

$(document).ready(function () {

    scrollTop = $(window).scrollTop();
    euLogo(scrollTop);

    /* Mobile hamburger
    ===========================*/
    $('.mobile-hamburger-toggle').on('click',function () {
        if ($(this).hasClass('toggled')) {
            $('html').removeClass('disable-scroll');
            $(this).removeClass('toggled');
            $('#menu-mobile .mobile-menu-drower').removeClass('show-menu-open-drower');
            setTimeout(function(){
                $('#menu-mobile').removeClass('show-menu');
            }, 500);
        } else {
            $('html').addClass('disable-scroll');
            $(this).addClass('toggled');
            $('#menu-mobile').addClass('show-menu');
            setTimeout(function(){
                $('#menu-mobile .mobile-menu-drower').addClass('show-menu-open-drower');
            }, 50);
        }
    });

    // $('#menu-mobile .menu-item-has-children>a').on('click', function(event) {
    //     event.preventDefault();
    //     event.stopImmediatePropagation();
    //     if ($(this).hasClass( "ow-show-submenu" )) {
    //         $(this).removeClass("ow-show-submenu");
    //         $(this).siblings('.sub-menu').slideUp('fast').removeClass("active");
    //     }
    //     else {
    //         $(this).addClass("ow-show-submenu");
    //         $(this).siblings('.sub-menu').slideToggle('fast').addClass("active");
    //     }
    // });

    $(window).scroll(function () {
        var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        if (winScroll > 20) {
            $('#header').addClass('scrolled');
        } else {
            $('#header').removeClass('scrolled');
        }
    });
    if ($(".gform_wrapper").length) {
        $(document).on('focus', '.gform_wrapper .ginput_container:not(.ginput_complex) input', function () {
            $(this).closest(".gfield").addClass("focused");
        });

        $(document).on('blur', '.gform_wrapper .ginput_container:not(.ginput_complex) input', function () {
            if ($(this).val() == '') {
                $(this).closest(".gfield").removeClass("focused");
            }
        });
        $(document).on('focus', '.gform_wrapper .ginput_container:not(.ginput_complex) textarea', function () {
            $(this).closest(".gfield").addClass("focused");
        });

        $(document).on('blur', '.gform_wrapper .ginput_container:not(.ginput_complex) textarea', function () {
            if ($(this).val() == '') {
                $(this).closest(".gfield").removeClass("focused");
            }
        });
        $(document).on('focus', '.gform_wrapper .ginput_complex input', function () {
            $(this).closest(".ginput_left").addClass("focused");
            $(this).closest(".ginput_right").addClass("focused");
        });

        $(document).on('blur', '.gform_wrapper .ginput_complex input', function () {
            if ($(this).val() == '') {
                $(this).closest(".ginput_left").removeClass("focused");
                $(this).closest(".ginput_right").removeClass("focused");
            }
        });
    }
    if ($(".checkout ").length) {
        $(document).on('focus', '.checkout input', function () {
            $(this).closest(".form-row").addClass("focused");
        });

        $(document).on('blur', '.checkout input', function () {
            if ($(this).val() == '') {
                $(this).closest(".form-row").removeClass("focused");
            }
        });
        $('.checkout input').each(
            function () {
                if ($(this).val() != '') {
                    $(this).closest(".form-row").addClass("focused");
                }
            }
        );
    }
    $('#footer .widget-title').click(function () {
        console.log($(window).width());
        if ($(window).width() < 768) {
            if ($(this).hasClass("active")) {
                $('.widget-title').removeClass("active");
                $(this).next().slideUp('fast').removeClass("active");
            } else {
                $('.widget-title').removeClass("active");
                $(this).addClass("active");
                $(this).next().slideToggle('fast').addClass("active");
                //Hide the other panels
                $(".widget-title + div").not($(this).next()).slideUp('fast').removeClass("active");
            }
        }
    });
    $('.widget-area .widget-title').click(function () {
        if ($(this).hasClass("active")) {
            $('.widget-title').removeClass("active");
            $(this).next().slideUp('fast').removeClass("active");
        } else {
            $('.widget-title').removeClass("active");
            $(this).addClass("active");
            $(this).next().slideToggle('fast').addClass("active");
            //Hide the other panels
            $(".widget-title + ul").not($(this).next()).slideUp('fast').removeClass("active");
        }
    });

    // $('.single_add_to_cart_button').click(function() {
    //     if($(this).hasClass("disabled")) {
    //         $(this).removeClass("disabled");
    //     }
    // });

    //disable pop up notifications on single product page
    // var $variationWrap = $('.single_variation_wrap');
    // $variationWrap.off('click', '.single_add_to_cart_button');
    // $variationWrap.on(
    //     'click', '.single_add_to_cart_button',
    //     function() {
    //         var $button =  $('.single_add_to_cart_button');
    //         $button.removeClass('disabled');
    //     }
    // );

    

});


//mobile header add toggle btn
document.addEventListener( 'DOMContentLoaded', function () {
    const container = document.getElementById( 'ow-menu-mobile' );
    if ( ! container ) {
        return;
    }
    // Add dropdown toggle that displays child menu items.
    const handheld = document.getElementsByClassName(
        'mobile-menu-drower'
    );
    if ( handheld.length > 0 ) {
        [].forEach.call(
            handheld[ 0 ].querySelectorAll(
                '.menu-item-has-children > a, .page_item_has_children > a'
            ),
            function ( anchor ) {
                // Add dropdown toggle that displays child menu items
                const btn = document.createElement( 'button' );
                btn.setAttribute( 'aria-expanded', 'false' );
                btn.classList.add( 'dropdown-toggle' );

                const btnSpan = document.createElement( 'span' );
                btn.appendChild( btnSpan );

                anchor.parentNode.insertBefore( btn, anchor.nextSibling );

                // Add event listener
                btn.addEventListener( 'click', function () {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    if ($(this).hasClass( "ow-show-submenu" )) {
                        $(this).removeClass("ow-show-submenu");
                        $(this).siblings('.sub-menu').slideUp('fast').removeClass("active");
                    }
                    else {
                        $(this).addClass("ow-show-submenu");
                        $(this).siblings('.sub-menu').slideToggle('fast').addClass("active");
                    }
                } );
            }
        );
    }
} );